"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonadResult = void 0;
const validate_1 = require("../validate");
class MonadResult {
    constructor(data, error) {
        this.data = data;
        this.error = error;
        if (!data && !error) {
            throw new validate_1.ValidationError('MonadResult must have either data or error, neither given.');
        }
        if (data && error) {
            throw new validate_1.ValidationError('MonadResult must have either data or error, both given.');
        }
    }
    static ofSuccess(data) {
        return new MonadResult(data, null);
    }
    static ofError(error) {
        return new MonadResult(null, error);
    }
    isSuccess() {
        return this.data != null;
    }
    isError() {
        return this.error != null;
    }
    getData() {
        return this.data;
    }
    requireData() {
        validate_1.Validator.notNil(this.data, 'Cannot require data: MonadResult is not successful');
        return this.data;
    }
    getError() {
        return this.error;
    }
    requireError() {
        validate_1.Validator.notNil(this.error, 'Cannot require error: MonadResult is not an error');
        return this.error;
    }
}
exports.MonadResult = MonadResult;
//# sourceMappingURL=MonadResult.js.map